// extracted by mini-css-extract-plugin
export default {"MessageOptions":"MessageOptions_MessageOptions__vdp0a","Upward":"MessageOptions_Upward__VqXZ0","Option":"MessageOptions_Option__seLah","Icon":"MessageOptions_Icon__zRoWB"};